import React, { FC } from 'react'
import { breakpointUp, styled } from '@moonpig/launchpad-utils'
import { Flex, Image } from '@moonpig/launchpad-components'
import { system as s } from '@moonpig/launchpad-system'

const ImageWrapper = styled(Flex)`
  width: 100%;
  height: auto;
  align-items: start;
  max-height: 320px;

  ${breakpointUp('md')} {
    align-items: center;
    max-height: 260px;
    overflow: hidden;
  }
`

const StyledImageDesktop = styled(Image)`
  display: none;
  object-fit: cover;

  ${s({
    width: '100%',
    borderRadius: 4,
  })}

  ${breakpointUp('md')} {
    display: block;
  }
`

const StyledImageMobile = styled(Image)`
  display: block;

  ${s({
    width: '100%',
    borderRadius: '16px 16px 0 0',
  })}

  ${breakpointUp('md')} {
    display: none;
  }
`

type Props = {
  images: {
    xs: string
    md: string
    description?: string
  }
}

export const BannerImage: FC<Props> = ({ images }) => {
  return (
    <ImageWrapper>
      <StyledImageMobile src={images.xs} />
      <StyledImageDesktop src={images.md} />
    </ImageWrapper>
  )
}
